import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import AnalyticsDrilldownModal from "./AnalyticsDrilldownModal";

const AverageTicketClosureTimeChart = ({ data, filters }) => {
    const [drilldownInfo, setDrilldownInfo] = useState({ isOpen: false, month: null, title: "" });

    if (!data) return <div>Loading Analytics...</div>;

    const { trends, current_month_avg, change, percent_change } = data;

    const categories = trends.map(t => t.month_label);
    const avgData = trends.map(t => parseFloat(t.avg_days));

    const options = {
        chart: {
            type: 'spline'
        },
        title: {
            text: 'Average Ticket Closure Time (Monthly Trend)',
            style: { fontWeight: '600', fontSize: '16px' }
        },
        xAxis: {
            categories: categories,
            gridLineWidth: 0,
            lineColor: '#e5e7eb'
        },
        yAxis: {
            title: { text: 'Days' },
            gridLineDashStyle: 'Dash',
            gridLineColor: '#f3f4f6'
        },
        tooltip: {
            shared: true,
            useHTML: true,
            headerFormat: '<b>{point.key}</b><br/>',
            pointFormat: 'Avg Closure Time: <b>{point.y} days</b><br/>' +
                '<span style="color: #666; font-size: 11px">Click to see ticket details</span>'
        },
        plotOptions: {
            spline: {
                marker: {
                    enabled: true,
                    radius: 4,
                    fillColor: '#FFFFFF',
                    lineWidth: 2,
                    lineColor: null // inherits from series
                },
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            const monthData = trends[this.index];
                            setDrilldownInfo({
                                isOpen: true,
                                month: monthData.month,
                                title: `Tickets Closed in ${monthData.month_label}`
                            });
                        }
                    }
                }
            }
        },
        series: [{
            name: 'Avg Days',
            data: avgData,
            color: '#ef4444', // Red
            lineWidth: 3
        }],
        credits: { enabled: false }
    };

    return (
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col h-full">
            {/* KPI Summary */}
            <div className="flex justify-between items-start mb-6">
                <div>
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wider">Current Month Avg</p>
                    <div className="flex items-baseline gap-2">
                        <h2 className="text-3xl font-bold text-gray-900">{current_month_avg} Days</h2>
                        <div className={`flex items-center text-sm font-semibold ${change <= 0 ? 'text-green-600' : 'text-red-600'}`}>
                            {change <= 0 ? '↓' : '↑'} {Math.abs(change)} from last month
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-grow">
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>

            <AnalyticsDrilldownModal
                isOpen={drilldownInfo.isOpen}
                onClose={() => setDrilldownInfo({ ...drilldownInfo, isOpen: false })}
                title={drilldownInfo.title}
                type="closure"
                month={drilldownInfo.month}
                filters={filters}
            />
        </div>
    );
};

export default AverageTicketClosureTimeChart;
